export default "__VITE_ASSET__Be10rwKb__"